export const ECOSYSTEM_MANIFEST = {
  tag: "TEAM MANIFEST // 05",
  status: "ECOSYSTEM CLASS",
  headline: "It's not a \"bot\". It is an enterprise ecosystem",
  lead:
    "A weekend bot is one person with a prompt. FractoLabs is three disciplines stress-testing before you deploy.",
  botLabel: "Weekend Bot",
  botLead:
    "A custom GPT or linear Make scenario works until a real user stress-tests the edges.",
  ecosystemLabel: "FractoLabs Ecosystem",
  ecosystemLead:
    "Production infrastructure built by three disciplines, not a single prompt pasted into Zapier.",
};

export const BOT_FAILURE_TRIGGERS = [
  {
    id: "context",
    title: "Context collapse",
    detail: "Three questions at once and the bot loses the thread.",
  },
  {
    id: "data",
    title: "Bad data in",
    detail: "Corrupted zip code accepted, so false bookings hit the CRM.",
  },
  {
    id: "guardrail",
    title: "Guardrail bypass",
    detail: "User talks their way to free services and rules fail.",
  },
];

export const BUILD_CREW = [
  {
    id: "ba",
    role: "Business Analyst",
    stat: "105+",
    statLabel: "edge cases mapped",
    description: "Every human objection, loophole, and off-script path documented before a line of code ships.",
  },
  {
    id: "eng",
    role: "Systems Engineer",
    stat: "100+",
    statLabel: "capabilities",
    description: "Isolated capabilities orchestrated through clean pipelines, not one overloaded prompt.",
  },
  {
    id: "qa",
    role: "QA Tester",
    stat: "Stress",
    statLabel: "tested",
    description: "Automated scenarios simulate attacks, spam, intent switches, and operational failure modes.",
  },
];

export const COMPARISON_ROWS = [
  {
    id: "orchestration",
    shortLabel: "Orchestration",
    node: "Thinking Logic (Orchestration)",
    amateur:
      "Single-Prompt. All context is crammed into one instruction. The bot quickly forgets the start of the conversation, gets confused, and outputs system gibberish.",
    fractolabs:
      "100+ Capability Pipeline. Messages are parsed and routed intelligently. Each task (geo, price, calendar) is handled by a dedicated system function.",
    owner: "Systems Architect / Backend Engineer",
  },
  {
    id: "guardrails",
    shortLabel: "Guardrails",
    node: "AI Behavior (Guardrails)",
    amateur:
      "Probabilistic. The bot tries to follow instructions but under user pressure agrees to 90% discounts or invents non-existent services.",
    fractolabs:
      "Deterministic. Responses are filtered through a hard Policy Engine. The bot physically cannot violate company rules or confirm out-of-scope services.",
    owner: "Business Analyst",
  },
  {
    id: "geodata",
    shortLabel: "Geodata",
    node: "Geodata Validation (Location)",
    amateur:
      "Text-based trust. The bot believes the user. If a client writes a non-existent address or a city in another state, the bot continues and books them.",
    fractolabs:
      "API approximation. Google Geocoding integration. The system computes distance via Haversine and instantly blocks leads outside the travel radius.",
    owner: "Systems Engineer",
  },
  {
    id: "pricing",
    shortLabel: "Pricing",
    node: "Pricing (Accountant)",
    amateur:
      "Chaotic. The bot either stays completely silent on prices or generates exact estimates, exposing the company to legal risk from incorrect calculations.",
    fractolabs:
      "Repetition Ladder. The bot uses a dynamic answer ladder: regulated price range → shortened answer → hard pivot to booking.",
    owner: "Business Analyst + Prompt Engineer",
  },
  {
    id: "calendar",
    shortLabel: "Calendar",
    node: "Calendar Synchronization",
    amateur:
      "External link. The bot drops a Calendly/GHL link. The lead must leave the chat, click, and fill out a form again. Conversion drops.",
    fractolabs:
      "Native Two-Way Sync. The bot parses natural language time, pulls free slots via API into the dialogue, and writes data to CRM.",
    owner: "Integrations Specialist / API Engineer",
  },
  {
    id: "fail-safe",
    shortLabel: "Fail-Safe",
    node: "Fail-Safe Resilience",
    amateur:
      "Scenario crash. If OpenAI or CRM hangs, the Make scenario throws a 400/500 error and the chat dies. Lead lost forever.",
    fractolabs:
      "Silent-Fail Guard. On external API failure, the system seamlessly switches to an autonomous buffer, saves history, and initiates a correct human handoff.",
    owner: "DevOps / Systems Engineer",
  },
  {
    id: "qa",
    shortLabel: "QA",
    node: "Testing & Reliability",
    amateur:
      "\"Clicked around in chat.\" Testing is limited to 5–10 personal messages. On the first non-standard phrase from a real client, the bot breaks.",
    fractolabs:
      "105+ QA Scenarios. Every backend release passes automated stress tests simulating attacks, spam, intent switches, and aggression.",
    owner: "QA Engineer",
  },
  {
    id: "memory",
    shortLabel: "Memory",
    node: "Memory & Context (State Management)",
    amateur:
      "Linear amnesia. The bot reads only the last 5–10 messages. In long dialogues it forgets the lead's name and problem and re-asks questions.",
    fractolabs:
      "Multi-dimensional tracking (113+ vectors). The bot continuously rewrites Runtime State, tracking 113+ lead parameters and cross-checking 120+ global business rules every turn.",
    owner: "Data Architect / Database Engineer",
  },
];
